import { ChangeEvent, InputHTMLAttributes, forwardRef } from 'react';
import Form from 'react-bootstrap/Form';
import { useDecimalInput } from '../../../Services/decimalInput';

type Props = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'onChange' | 'value' | 'size'
> & {
  value?: unknown;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  size?: 'sm' | 'lg';
  isInvalid?: boolean;
};

/**
 * Substitui <Form.Control type="number">: aceita vírgula ou ponto em qualquer
 * idioma do navegador e entrega `e.target.value` com ponto ao onChange.
 * Ver Services/decimalInput.
 */
const FormControlDecimal = forwardRef<HTMLInputElement, Props>(
  ({ value, onChange, min, step, type, ...props }, ref) => {
    const decimal = useDecimalInput(value, onChange, { min });

    return <Form.Control {...props} ref={ref} {...decimal} />;
  }
);

export default FormControlDecimal;
